import { FC, ReactElement } from 'react'

import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import * as BaseLayoutStyled from './BaseLayout.styled'

interface BaseLayoutProps {
  inputComponent: ReactElement
  resultComponent: ReactElement
  className?: string
  testId?: string
}

export const BaseLayout: FC<BaseLayoutProps> = ({ inputComponent, resultComponent, className, testId }) => {
  const usedTestId = testId ?? 'base-layout'
  return (
    <BaseLayoutStyled.Container
      contentWidth={'medium'}
      className={className}
      data-testid={createTestId(usedTestId, 'wrapper')}
    >
      <BaseLayoutStyled.Content id={'base-layout__content'} data-testid={createTestId(usedTestId, 'content')}>
        <BaseLayoutStyled.Input id='input-section' data-testid={createTestId(usedTestId, 'input-section')}>
          {inputComponent}
        </BaseLayoutStyled.Input>
        <BaseLayoutStyled.Result id='result-section' data-testid={createTestId(usedTestId, 'result-section')}>
          {resultComponent}
        </BaseLayoutStyled.Result>
      </BaseLayoutStyled.Content>
    </BaseLayoutStyled.Container>
  )
}
